/* eslint-disable import/default */

import React from "react";
import { init } from "@sentry/browser";
import { render } from "react-dom";
import { history } from "./store/configureStore";
import moment from "moment";
import momentDurationFormatSetup from "moment-duration-format";
import Root from "@common/Root";
import analyticsService from "@common/services/analyticsService";
import { setUpWifiListeners } from "@common/util/wifiListener";
import { store } from "./store";
import "./styles/styles.scss";
momentDurationFormatSetup(moment);

console.dev = function (message) {
  if ("production" === "development") {
    console.log(`%cDEBUG: ` + `%c${message}`, "color: green;", "color: black;");
  }
};

// Initialize analytics
analyticsService.init();
analyticsService.register();

//set up and init serviceworkers
if ("serviceWorker" in navigator) {
  if ("production" === "development") {
    // Automatically unregister active service workers in development to avoid caching/Vite dev conflicts
    navigator.serviceWorker.getRegistrations().then((registrations) => {
      for (const registration of registrations) {
        registration.unregister().then((unregistered) => {
          if (unregistered) {
            console.log("Stale dev SW unregistered successfully");
            window.location.reload();
          }
        });
      }
    });
  } else {
    // In production, check if we have a stale Webpack/Workbox service worker and clean it up
    if ("caches" in window) {
      caches.keys().then((keys) => {
        const hasWorkboxCache = keys.some((key) => key.includes("workbox"));
        if (hasWorkboxCache) {
          // Clear all caches
          keys.forEach((key) => caches.delete(key));
          // Unregister service workers so the new OneSignal one can register clean
          navigator.serviceWorker.getRegistrations().then((registrations) => {
            for (const registration of registrations) {
              registration.unregister();
            }
            console.log("Stale Webpack service worker and caches cleared");
            // Reload to ensure we fetch the fresh Vite app from the network
            window.location.reload();
          });
        } else {
          // Standard registration for the new service worker
          window.addEventListener("load", () => {
            navigator.serviceWorker
              .register("/service-worker.js")
              .then((registration) => {
                console.log("SW registered: ", registration);
              })
              .catch((registrationError) => {
                console.log("SW registration failed: ", registrationError);
              });
          });
        }
      });
    } else {
      // Fallback standard registration
      window.addEventListener("load", () => {
        navigator.serviceWorker
          .register("/service-worker.js")
          .then((registration) => {
            console.log("SW registered: ", registration);
          })
          .catch((registrationError) => {
            console.log("SW registration failed: ", registrationError);
          });
      });
    }
  }
}

// Set up error reporting with sentry.io
if ("production" !== "development") {
  try {
    init({
      dsn: "https://988cdcf78f574e4ca61781dd17bd6841@sentry.elements.nl/5" || "",
      environment: "Production" || "Local",
    });
  } catch (e) {
    console.log(e);
  }
}

// Set up wifi listener to see if the user has a internet connection
setUpWifiListeners(store.dispatch);

// Index is mainly used to configure hot module reload
// and to pass a configured store and router history to the Root component
render(
  <Root store={store} history={history} />,
  document.getElementById("app"),
);
